import React from 'react'
import MaterialSymbol from '../material-symbol'

const PlayCircle = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="play_circle" {...props} />
))

PlayCircle.displayName = 'PlayCircle'

export default PlayCircle
